import { useEffect, useState } from "react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, Status } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function TimelineTab({ c, reload }) {
  const { can } = useAuth();
  const [events, setEvents] = useState([]);
  const [f, setF] = useState({ type: "hearing", title: "", date: "" });
  const load = () => api.get(`/cases/${c.id}/timeline`).then((r) => setEvents(r.data));
  useEffect(() => { load(); }, [c.id]); // eslint-disable-line
  const add = async () => {
    try { await api.post(`/cases/${c.id}/timeline`, { ...f, date: new Date(f.date).toISOString(), status: "scheduled" }); toast.success("Event listed; parties notified"); setF({ type: "hearing", title: "", date: "" }); load(); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid md:grid-cols-12 gap-6 mt-4">
      <Panel title="Case timeline — Application to Decision" className="md:col-span-8" testId="timeline-panel">
        <ol className="relative border-l border-slate-200 ml-2">
          {events.map((e) => (
            <li key={e.id} className="ml-5 pb-5 last:pb-0" data-testid={`timeline-event-${e.type}`}>
              <span className={`absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border-2 border-white ${e.status === "completed" ? "bg-emerald-500" : e.status === "overdue" ? "bg-rose-500" : e.status === "adjourned" ? "bg-slate-400" : "bg-blue-900"}`} />
              <div className="flex items-center gap-3"><span className="mono text-xs text-slate-500">{fmtDate(e.date)}</span><Status value={e.status} /></div>
              <div className="font-medium text-slate-900 mt-0.5">{e.title}</div>
              {e.notes && <div className="text-sm text-slate-600">{e.notes}</div>}
              <div className="text-xs text-slate-400">{e.actor}</div>
            </li>))}
        </ol>
      </Panel>
      {can("case.edit") && (
        <Panel title="List an event" className="md:col-span-4 self-start" testId="timeline-add-panel">
          <div className="space-y-3">
            <div><Label>Type</Label><select className="w-full h-9 border rounded-md px-2 text-sm" value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })} data-testid="event-type">
              {["hearing", "directions_hearing", "adr", "expert_exchange", "other"].map((t) => <option key={t} value={t}>{t}</option>)}</select></div>
            <div><Label>Title</Label><Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="event-title" /></div>
            <div><Label>Date</Label><Input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="event-date" /></div>
            <Button className="bg-blue-900 w-full" disabled={!f.title || !f.date} onClick={add} data-testid="event-submit">List event</Button>
          </div>
        </Panel>)}
    </div>
  );
}
